import React from 'react';
import language from "../../languages/language";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import {Button, Col, Row} from "antd";
import CameraOutlined from "@ant-design/icons/lib/icons/CameraOutlined";
import modalShow from "../../actions/modalShow";
import modalDismiss from "../../actions/modalDismiss";
import {PICTURE_MODAL} from "../../types";
import {connect} from "react-redux";
import PublicLayout from "../Public";
import messageShow from "../../actions/messageShow";
import {addFileName} from "../../Helpers/utils";
import showDocument from "../../actions/showDocument";
import addDocument from "../../actions/addDocument";

class Photo extends React.Component
{
    state={front:null,back:null,faces:0};

    componentDidMount()
    {
        let faces=0;
        if(this.props.uploadFilesInfo.length>this.props.documents.length)
            faces=this.props.uploadFilesInfo[this.props.documents.length].faces;
        this.setState({front:this.props.front,back:this.props.back,faces:faces})
    }

    continue=()=>
    {
        if(!this.state.front && this.state.faces>0)
        {
            this.props.messageShow({message: language[this.props.language].frontRequired, type: 'error'});
            return;
        }
        if(!this.state.back && this.state.faces>1)
        {
            this.props.messageShow({message: language[this.props.language].backRequired, type: 'error'});
            return;
        }
        this.props.addDocument({front:this.state.front,back:this.state.back}).then(()=>this.props.showDocument());
    };

    updatePicture=(front,picture)=>
    {
        this.props.modalDismiss();
        if(!picture)
            return;
        picture=picture.replace('data:image/png;base64,','');
        if(front)
            this.setState({front:{base64:picture,name:'front.png'}});
        else
            this.setState({back:{base64:picture,name:'back.png'}});
    };
    takePicture=(front)=>
    {
        this.props.modalShow({
            modalType: PICTURE_MODAL,
            modalProps: {footer: null, title: language[this.props.language].takePictureLabelOk},
            componentProps: {onOK:(picture)=>this.updatePicture(front,picture),onCancel: this.props.modalDismiss,
            language:this.props.language,message:front?language[this.props.language].takePictureFront:
                    language[this.props.language].takePictureBack}});

    };

    render()
    {
        return <PublicLayout title={'logo'} size={'large'}>
            <TitleAndInfo info={addFileName(this.props,language[this.props.language].signUpText4)}/>
            <Row type={'flex'}>
                {this.state.faces>0?<Col onClick={()=>this.takePicture(true)} style={{display:'flex',flex:1,backgroundColor:'#f8f8f8',
                    height:'130px',alignItems:'center',justifyContent:'center',margin:'5px 20px 10px 20px',cursor: 'pointer'}}>
                    {this.state.front?<img style={{maxWidth:'100%',maxHeight:'100%'}} alt={""}
                                           src={'data:image/png;base64,' + this.state.front.base64}/>:<><div style={{fontSize:'60px'}}>
                        <CameraOutlined/>
                    </div>
                        <div style={{fontSize:'30px',marginLeft:'10px'}}>
                            {language[this.props.language].frontIdLabel}
                        </div></>}
                </Col>:<></>}
                {this.state.faces>1?<Col onClick={()=>this.takePicture(false)} style={{display:'flex',flex:1,backgroundColor:'#f8f8f8',
                    height:'130px',alignItems:'center',justifyContent:'center',margin:'5px 20px 10px 20px',cursor: 'pointer'}}>
                    {this.state.back?<img style={{maxWidth:'100%',maxHeight:'100%'}} alt={""}
                                          src={'data:image/png;base64,' + this.state.back.base64}/>:<><div style={{fontSize:'60px'}}>
                        <CameraOutlined/>
                    </div>
                        <div style={{fontSize:'30px',marginLeft:'10px'}}>
                            {language[this.props.language].backIdLabel}
                        </div></>}
                </Col>:<></>}
            </Row>
            <Row justify={'space-around'} type={'flex'}>
                <Button type="primary light-blue rounded" onClick={this.props.showDocument}>
                    {language[this.props.language].backLabel}
                </Button>
                <Button type="primary light-blue rounded" onClick={this.continue}>
                    {language[this.props.language].createLabel}
                </Button>
            </Row>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        documents:state.info.documents,
        uploadFilesInfo: state.info.uploadFilesInfo,
        formValues: state.info
    }
}
function mapDispatchToProps(dispatch) {
    return {
        modalShow: (data) => dispatch(modalShow(data)),
        modalDismiss: () => dispatch(modalDismiss()),
        messageShow: (payload) => dispatch(messageShow(payload)),
        showDocument:()=>dispatch(showDocument()),
        addDocument:(file)=>dispatch(addDocument(file)),
        dispatch
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Photo);